// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2hKSJ","range":"MonthRangeSwitch_range__1-ymm","disabled":"MonthRangeSwitch_disabled__3W-GA"};